import React, {useContext} from 'react';
import {Route, Switch} from "react-router-dom";
import Home from "pages/home/Home";
import TradeEntryPanel from "pages/tradecapture/TradeEntryPanel";
import TradeUpload from "pages/tradecapture/TradeUpload";
import Trade from "pages/tradecapture/Trade";
import Queries from "pages/query/Queries";
import Reports from "pages/reports/Reports";
import Wires from "pages/wires/Wires";
import Mmf from "pages/disclaimer/MMF";
import ShortSaleApprovals from "pages/shortsale/ShortSaleApprovals";
import ProfilePanel from "pages/profile/ProfilePanel";
import ChangePasswordPanel from "pages/profile/ChangePasswordPanel";
import PasswordResetSuccess from "pages/profile/PasswordResetSuccess";
import ShortSaleHistory from "pages/shortsale/ShortSaleHistory";
import ShortSalePersistDetails from "pages/shortsale/ShortSalePersistDetails";
import QueriesPanel from "../pages/query/QueriesPanel";
import DefaultHome from "pages/home/DefaultHome";
import UserRoleService, {
    HOME_MENU_PERMISSION_KEY,
    QUERIES_MENU_PERMISSION_KEY,
    REPORTS_MENU_PERMISSION_KEY,
    SSA_MENU_PERMISSION_KEY,
    TRADE_MENU_PERMISSION_KEY,
    WIRES_MENU_CLIENT_APPROVER_PERMISSION_KEY,
    TRADE_MENU_UPLOAD_PERMISSION_KEY,
    WIRES_MENU_VIEW_ONLY_PERMISSION_KEY,
    TRADE_MENU_BREAK_PERMISSION_KEY,
    ASSET_TRANSFER_SUBMITTER, ASSET_TRANSFER_INTERNAL_USER, ASSET_TRANSFER_VIEWONLY, WEB_ANNOUNCEMENTS_PERMISSION_KEY,
    CP_ADMIN_SCREEN
} from "../service/UserRoleService";
import TradeBreaks from "pages/tradecapture/TradeBreaks";
import MnyWires from "pages/admin/moneywires/MnyWires";
import WireTemplates from "pages/admin/wiretemplate/WireTemplates";
import {ShortSaleContext} from "../pages/shortsale/context";
import AssetTransferList from "../pages/wires/AssetTransferList";
import AssetTransferUpload from "../pages/wires/AssetTransferUpload";
import AssetTransferEntryPanel from "../pages/wires/AssetTransferEntryPanel";
import FooterReportsPanel from "../pages/footerreports/FooterReportsPanel";
import WebAnnouncements from "../pages/admin/webannouncements/WebAnnouncements";
import SwiftTransaction from "../pages/admin/transactions/SwiftTransaction";
import Swift from "pages/admin/swift/Swift";
import SwiftWiresList from "../pages/admin/swiftwires/SwiftWiresList";
import AddNewWireTemplateStep1 from "../pages/admin/wiretemplate/AddNewWireTemplateStep1";
import AddNewWireTemplateStep2 from "../pages/admin/wiretemplate/AddNewWireTemplateStep2";
import AddNewWireTemplateStep3 from "../pages/admin/wiretemplate/AddNewWireTemplateStep3";
import AddNewWireTemplateStep4 from "../pages/admin/wiretemplate/AddNewWireTemplateStep4";
import AddNewWireTemplateStep5 from "../pages/admin/wiretemplate/AddNewWireTemplateStep5";
import AddNewWireTemplateStep6 from "../pages/admin/wiretemplate/AddNewWireTemplateStep6";

export const HOME = "/";
export const FOOTER_REPORTS_PANEL = '/footer-reports'
export const QUERIES = "/reporting/queries";
export const QUERIES_PANEL = "/reporting/QueriesPanel";
export const REPORTS = "/reporting";
export const WIRES = "/asset-transfers/wires";
export const ASSET_TRANSFER_LIST = "/asset-transfers/list";
export const ASSET_TRANSFER_UPLOAD = "/asset-transfers/upload";
export const ASSET_TRANSFER_ENTRY = "/asset-transfers/asset-transfer-entry-panel";
export const ASSERTTRANSFER_ENTRY = "/asset-transfers/asset-transfer-entry-panel";
export const SWIFT_WIRES_LIST = "/swift-wires/list";
export const TRADECAPTURE_LIST = "/trading/list";
export const TRADECAPTURE_ENTRY = "/trading/trade-entry-panel";
export const TRADECAPTURE_UPLOAD = "/trading/upload";
export const TRADECAPTURE_BREAKS = "/trading/breaks";
export const MMF = "/disclaimer/MMF";
export const SHORTSALE_APPROVAL_PERSIST_DETAILS = "/shortsale-approval-persist-details";
export const SHORTSALE_APPROVAL_HISTORY = "/shortsale-approval-history";
export const SHORTSALE_APPROVAL_LOCATE = "/shortsale-approval-locate";
export const SHORTSALE_APPROVAL_UPLOAD = "/shortsale-approval-upload";
export const SHORTSALE_APPROVAL_SEARCH = "/shortsale-approval-search"
export const SHORTSALE_APPROVAL_PASTE_FROM_CLIPBOARD = "/shortsale-approval-paste-from-clipboard"
export const PROFILE = "/Profile/ProfilePanel";
export const CHANGE_PASSWORD = "/Profile/ChangePasswordPanel";
export const CHANGE_PASSWORD_SUCCESS = "/Profile/PasswordResetSuccess";
export const MNYWIRE = "/admin/money-wires";
export const WIRE_TEMPLATE = "/admin/wire-templates";
export const WIRE_TEMPLATE_NEW_STEP1 = "/admin/wire-templates-new-step1";
export const WIRE_TEMPLATE_NEW_STEP2 = "/admin/wire-templates-new-step2";
export const WIRE_TEMPLATE_NEW_STEP3 = "/admin/wire-templates-new-step3";
export const WIRE_TEMPLATE_NEW_STEP4 = "/admin/wire-templates-new-step4";
export const WIRE_TEMPLATE_NEW_STEP5 = "/admin/wire-templates-new-step5";
export const WIRE_TEMPLATE_NEW_STEP6 = "/admin/wire-templates-new-step6";
export const WEB_ANNOUNCEMENTS = "/admin/webannouncements";
export const SWIFT_TRANSACTIONS = "/admin/swift-transactions";
export const SWIFT_MESSAGE_SEARCH = "/admin/swift-message-search"
export default function Routes() {

    const {setShowBadge} = useContext(ShortSaleContext);
    const checkPermission = (menuKey,menuName='') => {
        let permission = UserRoleService.hasPermission(menuKey)
        if(![SHORTSALE_APPROVAL_LOCATE, SHORTSALE_APPROVAL_UPLOAD, SHORTSALE_APPROVAL_PASTE_FROM_CLIPBOARD,SHORTSALE_APPROVAL_SEARCH].includes(menuName) && permission) {
            setShowBadge(false)
        }
        return permission;
    }

    return(
        <>
            <Switch>
                <Route exact path={HOME} render={()=> checkPermission(HOME_MENU_PERMISSION_KEY) ? <Home/> : <DefaultHome/> }/>
                <Route exact path={`${FOOTER_REPORTS_PANEL}/:fileName`} component={FooterReportsPanel} />
                <Route exact path={QUERIES} render={()=> checkPermission(QUERIES_MENU_PERMISSION_KEY) ? <Queries/> : <DefaultHome/> }/>
                <Route exact path={QUERIES_PANEL} render={()=> checkPermission(QUERIES_MENU_PERMISSION_KEY) ? <QueriesPanel/> : <DefaultHome/> }/>
                <Route exact path={REPORTS} render={()=> checkPermission(REPORTS_MENU_PERMISSION_KEY) ? <Reports/> : <DefaultHome/> }/>
                <Route exact path={WIRES} render={()=> checkPermission(WIRES_MENU_CLIENT_APPROVER_PERMISSION_KEY)  || checkPermission(WIRES_MENU_VIEW_ONLY_PERMISSION_KEY) ? <Wires/> : <DefaultHome/> }/>
                <Route exact path={ASSET_TRANSFER_LIST} render={()=>  checkPermission(ASSET_TRANSFER_SUBMITTER) || checkPermission(ASSET_TRANSFER_INTERNAL_USER) || checkPermission(ASSET_TRANSFER_VIEWONLY) ? <AssetTransferList/> : <DefaultHome/> }/>
                <Route exact path={ASSET_TRANSFER_UPLOAD} render={()=>  checkPermission(ASSET_TRANSFER_SUBMITTER) || checkPermission(ASSET_TRANSFER_INTERNAL_USER) ? <AssetTransferUpload/> : <DefaultHome/> }/>
                <Route exact path={ASSET_TRANSFER_ENTRY + "/:id"} render={()=>  checkPermission(ASSET_TRANSFER_SUBMITTER) || checkPermission(ASSET_TRANSFER_INTERNAL_USER) || checkPermission(ASSET_TRANSFER_VIEWONLY) ? <AssetTransferEntryPanel/>:<DefaultHome />  }/>
                <Route exact path={ASSET_TRANSFER_ENTRY} render={()=>  checkPermission(ASSET_TRANSFER_SUBMITTER) || checkPermission(ASSET_TRANSFER_INTERNAL_USER) || checkPermission(ASSET_TRANSFER_VIEWONLY) ? <AssetTransferEntryPanel/>: <DefaultHome /> }/>

                <Route exact path={WIRES} render={()=> checkPermission(WIRES_MENU_CLIENT_APPROVER_PERMISSION_KEY)  || checkPermission(WIRES_MENU_VIEW_ONLY_PERMISSION_KEY) ? <Wires/> : <DefaultHome/> }/>
                <Route exact path={TRADECAPTURE_LIST} render={()=> checkPermission(TRADE_MENU_PERMISSION_KEY) ? <Trade/> : <DefaultHome/> }/>
                <Route exact path={TRADECAPTURE_ENTRY + "/:id"} render={()=> checkPermission(TRADE_MENU_PERMISSION_KEY) ? <TradeEntryPanel/> : <DefaultHome/> }/>
                <Route exact path={TRADECAPTURE_ENTRY} render={()=> checkPermission(TRADE_MENU_PERMISSION_KEY) ? <TradeEntryPanel/> : <DefaultHome/> }/>
                <Route exact path={TRADECAPTURE_UPLOAD} render={()=> checkPermission(TRADE_MENU_UPLOAD_PERMISSION_KEY) ? <TradeUpload/> : <DefaultHome/> }/>
                <Route exact path={TRADECAPTURE_BREAKS} render={()=> checkPermission(TRADE_MENU_BREAK_PERMISSION_KEY) ? <TradeBreaks/> : <DefaultHome/> }/>
                <Route exact path={MMF} component={Mmf}/>
                <Route exact path={SHORTSALE_APPROVAL_LOCATE} render={()=> checkPermission(SSA_MENU_PERMISSION_KEY,SHORTSALE_APPROVAL_LOCATE) ? <ShortSaleApprovals/> : <DefaultHome/> }/>
                <Route exact path={SHORTSALE_APPROVAL_HISTORY} render={()=> checkPermission(SSA_MENU_PERMISSION_KEY) ? <ShortSaleHistory/> : <DefaultHome/> }/>
                <Route exact path={SHORTSALE_APPROVAL_UPLOAD} render={()=> checkPermission(SSA_MENU_PERMISSION_KEY,SHORTSALE_APPROVAL_UPLOAD) ? <ShortSaleApprovals/> : <DefaultHome/> }/>
                <Route exact path={SHORTSALE_APPROVAL_SEARCH} render={()=> checkPermission(SSA_MENU_PERMISSION_KEY,SHORTSALE_APPROVAL_SEARCH) ? <ShortSaleApprovals/> : <DefaultHome/> }/>
                <Route exact path={SHORTSALE_APPROVAL_PASTE_FROM_CLIPBOARD} render={()=> checkPermission(SSA_MENU_PERMISSION_KEY,SHORTSALE_APPROVAL_PASTE_FROM_CLIPBOARD) ? <ShortSaleApprovals/> : <DefaultHome/> }/>
                <Route exact path={SHORTSALE_APPROVAL_PERSIST_DETAILS} render={()=> checkPermission(SSA_MENU_PERMISSION_KEY) ? <ShortSalePersistDetails/> : <DefaultHome/> }/>
                <Route exact path={PROFILE} component={ProfilePanel}/>
                <Route exact path={CHANGE_PASSWORD} component={ChangePasswordPanel}/>
                <Route exact path={CHANGE_PASSWORD_SUCCESS} component={PasswordResetSuccess}/>
                <Route exact path={MNYWIRE} render={()=> checkPermission(CP_ADMIN_SCREEN) ? <MnyWires/> : <DefaultHome/> }/>
                <Route exact path={WIRE_TEMPLATE} render={()=> checkPermission(CP_ADMIN_SCREEN) ? <WireTemplates/> : <DefaultHome/> }/>
                <Route exact path={WIRE_TEMPLATE_NEW_STEP1} render={()=>  checkPermission(CP_ADMIN_SCREEN) ? <AddNewWireTemplateStep1/> : <DefaultHome/> }/>
                <Route exact path={WIRE_TEMPLATE_NEW_STEP2} render={()=>  checkPermission(CP_ADMIN_SCREEN) ? <AddNewWireTemplateStep2/> : <DefaultHome/> }/>
                <Route exact path={WIRE_TEMPLATE_NEW_STEP3} render={()=>  checkPermission(CP_ADMIN_SCREEN)? <AddNewWireTemplateStep3/> : <DefaultHome/> }/>
                <Route exact path={WIRE_TEMPLATE_NEW_STEP4} render={()=> checkPermission(CP_ADMIN_SCREEN)? <AddNewWireTemplateStep4/> : <DefaultHome/> }/>
                <Route exact path={WIRE_TEMPLATE_NEW_STEP5} render={()=> checkPermission(CP_ADMIN_SCREEN) ? <AddNewWireTemplateStep5/> : <DefaultHome/> }/>
                <Route exact path={WIRE_TEMPLATE_NEW_STEP6} render={()=> checkPermission(CP_ADMIN_SCREEN) ? <AddNewWireTemplateStep6/> : <DefaultHome/> }/>
                <Route exact path={WEB_ANNOUNCEMENTS} render={()=> checkPermission(WEB_ANNOUNCEMENTS_PERMISSION_KEY) ? <WebAnnouncements/> : <DefaultHome/> }/>
                <Route exact path={SWIFT_TRANSACTIONS} render={()=> checkPermission(CP_ADMIN_SCREEN) ? <SwiftTransaction/> : <DefaultHome/> }/>
                <Route exact path={SWIFT_WIRES_LIST} render={()=> checkPermission(CP_ADMIN_SCREEN) ? <SwiftWiresList /> : <DefaultHome/> }/>
                <Route exact path={SWIFT_MESSAGE_SEARCH} render={()=> checkPermission(CP_ADMIN_SCREEN) ? <Swift/> : <DefaultHome/> }/>
            </Switch>
        </>
    );
}

